const Card = ({ name, icon, description, id, color }) => {
  return (
    <figure className="tech__card">
      {/* <i className={`${icon} tech__card-bg`} /> */}
      <div className="tech__card--main">
        <div className="tech__card--icon">
          <i
            role="img"
            aria-labelledby={id}
            className={`${icon}`}
            style={{ color: color }}
          ></i>
          <figcaption aria-hidden="true" id={id}>
            {name}
          </figcaption>
        </div>
        <div className="tech__card--description">
          <p>{description}</p>
        </div>
      </div>
    </figure>
  );
};

export default Card;
